import { UPDATE_HISTORY } from './actionTypes'

export const initializeHistory = () => (dispatch, getState) => {
  const historyItem = `history_${getState().auth.userId}`
  const initialHistory = JSON.parse(localStorage.getItem(historyItem))
  if (!initialHistory) localStorage.setItem(historyItem, JSON.stringify([]))

  return dispatch({
    type: UPDATE_HISTORY,
    payload: initialHistory || [],
  })
}

export const addSongToHistory = () => (dispatch, getState) => {
  const historyItemName = `history_${getState().auth.userId}`
  const retrievedHistory = JSON.parse(localStorage.getItem(historyItemName)) || []

  const { indicationType, songId, painLevelAfter, painLevelBefore } = getState().player

  const newHistoryEntry = {
    songId,
    indicationType,
    painLevelBefore,
    painLevelAfter,
    time: new Date().toString(),
  }
  const updatedHistoryList = [newHistoryEntry, ...retrievedHistory]
  localStorage.setItem(historyItemName, JSON.stringify(updatedHistoryList))

  return dispatch({
    type: UPDATE_HISTORY,
    payload: updatedHistoryList,
  })
}
